import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { useMemo } from 'react';
import { useCountries } from "../../../data/countries";
import { useLeadSources } from "../../../data/leadSources";
export function useApiDropdownList() {
  var _useLeadSources = useLeadSources(),
    leadSources = _useLeadSources.leadSources;
  var _useCountries = useCountries(),
    countries = _useCountries.countries;
  var leadSourcesDropdownOptions = useMemo(function () {
    return leadSources.map(function (item) {
      return {
        label: item.displayName,
        value: item.name
      };
    });
  }, [leadSources]);
  var countriesDropdownItems = useMemo(function () {
    return countries.map(function (item) {
      return {
        label: item.name,
        value: item.code
      };
    });
  }, [countries]);
  return {
    leadSourcesDropdownOptions: leadSourcesDropdownOptions,
    countriesDropdownItems: countriesDropdownItems
  };
}